/* eslint-disable react/no-danger */
import React, { FC, useMemo, useState, useCallback, useRef, useEffect } from 'react';
import classNames from 'classnames/bind';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import { PlpRatingWidgetProps } from './types';
import styles from './index.scss';
import { fetchRatingByUser, fetchUnratedRatingProducts } from '../../../actions/ratings';
import { showModal, hideModal, updateModal } from '../../../actions/shared/modal';

import { getUnratedItems } from '../../selectors/ratingSelector';
import DisplayRating from './DisplayRating';
import properties from '../../../modules/ajio-util/properties';
import FailureToast from '../../organism/RatingHalfCard/Msite/FailureToast';
import { getShowHomeRating, getEnableRating } from '../../selectors/featureFlagsSelector';
import RatedAll from '../RatedAll';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

const mapDispatchToProps = dispatch => {
  return {
    fetchUnratedRatingProducts: () => dispatch(fetchUnratedRatingProducts()),
    fetchRatingByUsers: (reqData: object) => {
      dispatch(fetchRatingByUser(reqData));
    },
    showModal: (name, config) => dispatch(showModal(name, config))
  };
};
const mapStateToProps = (state, ownProps) => {
  const unratedItems = getUnratedItems(state);
  const enableRating = getEnableRating(state?.flags,state);
  const showHomeRating = getShowHomeRating(state?.flags);
  return {
    unratedItems,
    enableRating,
    showHomeRating
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const PlpRatingWidget: FC<PlpRatingWidgetProps> = (props: PlpRatingWidgetProps) => {
  const {
    unratedProduct,
    fetchRatingByUsers,
    showModal,
    unratedItems,
    enableRating,
    showHomeRating,
    pageType = 'LP',
    topPart,
    widthPart,
    heightPart,
    bgPart,
    positionPart
  } = props;
  const { ratingTitle, widgetTitle, userUnratedItems } = unratedItems;

  const cx = classNames.bind(styles);
  const [successmsg, setSucceessMsg] = useState(false);
  const [isModalClose, setIsModalClose] = useState(false);
  const [clickedProduct, setClickedProduct] = useState(null);
  const [updatedRating, setUpdatedRating] = useState(null);
  const [isRating, setIsRating] = useState(false);
  const [isRatingFailed, setIsRatingFailed] = useState(false);
  const [apiSuccess, setApiSuccess] = useState(false);
  const [unrated, setUnrated] = useState(userUnratedItems);
  const imageBaseRef = `${properties.getProperty('imageBaseUrl')}/static/img/`;
  const [toast, setToast] = useState(false);
  const [showDiv, setShowDiv] = useState(false);
  const timer = useRef<NodeJS.Timeout>(null);
  const fetchUnratedItems = async () => {
    const response = await props.fetchUnratedRatingProducts();
    response && setApiSuccess(true);
    response && setIsRating(true);
    return response;
  };
  useEffect(() => {
    return () => clearTimeout(timer?.current);
  }, []);
  const slickSettings = {
    className: 'rating-home-widget',
    autoplay: false,
    infinite: false,
    arrows: false,
    indicators: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: 'slick-dots slick-thumb',
    customPaging: i => (
      <div
        type="button"
        data-role="none"
        role="button"
        tabIndex={i}
        key={i}
        className="home-slider-dots"
        style={{
          width: '24px',
          height: '4px',
          margin: '0 0 0 4px',
          borderRadius: '2px',
          backgroundColor: '#e8ebed'
        }}
      />
    )
  };

  const onCloseHideSlider = () => {
    setSucceessMsg(true);
    timer.current = setTimeout(() => {
      userUnratedItems && userUnratedItems.length === 1 ? setShowDiv(true) : setShowDiv(false);
      fetchUnratedItems();
    }, 5000);
  };

  const getUpdatedRating = (value = null) => {
    setUpdatedRating(value);
  };

  const getFailedRating = () => {
    setIsRatingFailed(true);
    setToast(true);
  };

  const hideToast = () => {
    setToast(false);
  };
  return (
    <>
      {showDiv ? (
        <RatedAll />
      ) : (
        userUnratedItems && (
          <div
            id="ratingContainer"
            style={{
              top: topPart,
              width: widthPart,
              height: heightPart,
              background: bgPart,
              position: positionPart
            }}
          >
            <Slider {...slickSettings}>
              {userUnratedItems.map((val, i) => {
                if (i < 3) {
                  return (
                    <div className={cx('rating-widget')} key={val.skuId}>
                      <div className={cx('rating-top-head')}>
                        <span className={cx('Rate-your-purchase')}>{widgetTitle}</span>
                      </div>
                      {/* img section will be left as per vds and it will dynamicall */}

                      {/* Logic for first 3 items */}
                      <div className={cx('unrated-product-details')}>
                        <div className={cx('left-rate-div')} style={{}}>
                          <img
                            src={replaceWithJioCDN(val.imageUrl)}
                            loading="eager"
                            className={cx('rating-product-card-image')}
                            alt="product image"
                          />
                        </div>

                        {/* main div */}
                        <div className={cx('right-rate-div')}>
                          {/* title div  */}
                          <p className={cx('prod-ttl')} id="product_title">
                            {val.brandName}
                          </p>
                          {/* subtitle div  */}
                          <p className={cx('prod-sub-ttl')} id="product_desc">
                            {val.brandTitle}
                          </p>
                          {/* rating  div  */}
                          <div className={cx('star-ratings')}>
                            <DisplayRating
                              data={val}
                              fetchRating={fetchRatingByUsers}
                              showModal={showModal}
                              onCloseHideSlider={onCloseHideSlider}
                              setClickedProduct={setClickedProduct}
                              isRating={isRating}
                              getUpdatedRating={getUpdatedRating}
                              failedRatingHandler={getFailedRating}
                              pageType={pageType}
                            />
                          </div>
                          <p className={cx('Tap-on-the-stars-to-rate-your-experience')}>
                            {successmsg && clickedProduct === val.skuId ? (
                              <>
                                <img
                                  className={cx('rated-img-icon')}
                                  src={`${imageBaseRef}rated-all-icon.svg`}
                                  alt='Tick icon'
                                />{' '}
                                <span> Rating Submitted</span>
                              </>
                            ) : (
                              ratingTitle
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
            </Slider>
          </div>
        )
      )}
      {isRatingFailed && <FailureToast displayToast={toast} hideToast={hideToast} />}
    </>
  );
};

PlpRatingWidget.defaultProps = {};

export default connector(PlpRatingWidget);
